import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/LevelCircle.css';

// LevelCircle component displays a circular progress indicator for user level and experience points (XP).
function LevelCircle({ level, xp, xpToNextLevel, disableAnimation = false }) {
  const navigate = useNavigate();
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const progress = (xp / xpToNextLevel) * 100;
  const [animatedProgress, setAnimatedProgress] = useState(disableAnimation ? progress : 0);

  useEffect(() => {
    if (!disableAnimation) {
      const timeout = setTimeout(() => {
        setAnimatedProgress(progress);
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, [xp, xpToNextLevel, progress, disableAnimation]);

  const strokeDashoffset = circumference * (1 - animatedProgress / 100);

  return (
    <div
      className="level-circle"
      onClick={() => navigate('/my-stats')}
      style={{ cursor: 'pointer' }}
    >
      <svg
        className="progress-ring"
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid meet"
      >
        <circle
          className="progress-ring__background"
          cx="50"
          cy="50"
          r={radius}
          strokeWidth="10"
        />
        <circle
          className="progress-ring__progress"
          cx="50"
          cy="50"
          r={radius}
          strokeWidth="10"
          style={{
            strokeDasharray: circumference,
            strokeDashoffset,
          }}
        />
      </svg>
      <div className="level-circle__content">
        <p className="level-circle__label">Level</p>
        <p className="level-circle__level">{level}</p>
      </div>
    </div>
  );
}

export default LevelCircle;